<template>
  <div class="md:flex md:items-center md:justify-between mb-3">
    <div class="flex-1 min-w-0">
      <h2 class="text-xl font-bold tracking-tight text-foreground lg:text-2xl">
        Transactions
      </h2>
    </div>
    <div class="mt-4 flex md:mt-0 md:ml-4">
      <button v-if="gateway && gateway !== 'paypal'"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500"
              type="button"
              @click="openReport(gateway, 'simplifie')"
      >
        Rapport simplifié
      </button>

      <Menu v-if="gateway && gateway === 'paypal'" as="div" class="ml-3 relative inline-block text-left">
        <MenuButton class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500">
          Rapport simplifié
          <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5" aria-hidden="true"/>
        </MenuButton>
        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
            <div class="py-1">
              <MenuItem v-slot="{ active }">
                <a href="#" @click.prevent="openReport('paypal', 'simplifie')"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">
                  Ancien
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">
                <a href="#" @click.prevent="openReport('paypal_sftp', 'simplifie')"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">
                  Nouveau
                </a>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>

      <button v-if="gateway && gateway !== 'paypal' && gateway !== 'europe' && gateway !== 'europe_pro'"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500"
              type="button"
              @click="openReport(gateway, 'complet')"
      >
        Rapport complet
      </button>

      <Menu v-if="gateway && gateway === 'paypal'" as="div" class="ml-3 relative inline-block text-left">
        <MenuButton class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500">
          Rapport complet
          <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5" aria-hidden="true"/>
        </MenuButton>
        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
            <div class="py-1">
              <MenuItem v-slot="{ active }">
                <a href="#" @click.prevent="openReport('paypal', 'complet')"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">
                  Ancien
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">
                <a href="#" @click.prevent="openReport('paypal_sftp', 'complet')"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">
                  Nouveau
                </a>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>
      <div class="ml-3  relative rounded-md shadow-sm">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <SearchIcon
              class="h-5 w-5 text-gray-400"
              aria-hidden="true"
          />
        </div>
        <form id="search">
          <input
              v-model="searchQuery"
              type="text"
              name="query"
              class="inline-flex focus:ring-indigo-500  px-4  py-2 focus:border-indigo-500 block w-full min-w-0  pl-10 sm:text-sm border-gray-300 rounded-md"
              @input="saveToLocalStorage('filterKey', $event.target.value)"
          >
        </form>
      </div>
      <Menu as="div" class="ml-3 relative inline-block text-left">
        <div>
          <MenuButton
              class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">
            {{ dateChoose ? dateChoose : "" }}
            <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5" aria-hidden="true"/>
          </MenuButton>
        </div>

        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems
              class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none">
            <div class="py-1">
              <MenuItem v-slot="{ active }" v-for="date in monthYearList" :key="date">
                <a href="#"
                   @click="updateDateChoose(date)"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <DuplicateIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true"/>
                  {{ date }}
                </a>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>

  </div>
  <div class="sm:hidden">
    <label
        class="sr-only"
        for="tabs"
    >Select a tab</label>
    <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
    <select
        id="tabs"
        class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
        name="tabs"
    >
      <option
          v-for="tab in tabs"
          :key="tab.name"
          :selected="tab.current"
      >
        {{ tab.name }}
      </option>
    </select>
  </div>

  <!-- Statistics Banner -->
  <div class="mt-4 mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
    <div class="bg-gradient-to-br from-indigo-50 to-indigo-100 overflow-hidden rounded-xl border border-indigo-200">
      <div class="px-4 py-3">
        <dt class="text-xs font-medium text-indigo-600 uppercase tracking-wide">{{ statisticsTitle }}</dt>
        <dd class="mt-1 text-2xl font-bold text-indigo-900">{{ statistics.count }}</dd>
      </div>
    </div>
    <div class="bg-gradient-to-br from-emerald-50 to-emerald-100 overflow-hidden rounded-xl border border-emerald-200">
      <div class="px-4 py-3">
        <dt class="text-xs font-medium text-emerald-600 uppercase tracking-wide">Montant total</dt>
        <dd class="mt-1 text-2xl font-bold text-emerald-900">{{ statistics.total }} €</dd>
      </div>
    </div>
    <div class="bg-gradient-to-br from-red-50 to-red-100 overflow-hidden rounded-xl border border-red-200">
      <div class="px-4 py-3">
        <dt class="text-xs font-medium text-red-600 uppercase tracking-wide">Frais</dt>
        <dd class="mt-1 text-2xl font-bold text-red-900">−{{ statistics.fees }} €</dd>
      </div>
    </div>
    <div class="bg-gradient-to-br from-blue-50 to-blue-100 overflow-hidden rounded-xl border border-blue-200">
      <div class="px-4 py-3">
        <dt class="text-xs font-medium text-blue-600 uppercase tracking-wide">Net</dt>
        <dd class="mt-1 text-2xl font-bold text-blue-900">{{ statistics.net }} €</dd>
      </div>
    </div>
  </div>

  <div class="mt-0 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-hidden sm:-mx-6 lg:-mx-8 grid mt-1">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <!-- Onglets de passerelle, fusionnés avec le tableau (haut de carte) -->
        <div class="hidden sm:block">
          <nav aria-label="Tabs"
               class="flex flex-wrap gap-x-6 rounded-t-lg border border-b-0 border-gray-200 bg-gray-50 px-4">
            <router-link
                v-for="tab in tabs"
                :key="tab.name"
                :aria-current="tab.current ? 'page' : undefined"
                :class="[tab.href === $route.path ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'group inline-flex items-center py-2.5 px-1 border-b-2 font-medium text-sm']"
                :href="tab.href"
                :to="tab.href"
            >
              <component
                  :is="tab.icon"
                  :class="[tab.href === $route.path ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500', '-ml-0.5 mr-1.5 h-4 w-4']"
                  aria-hidden="true"
              />
              <span>{{ tab.name }}</span>
            </router-link>
          </nav>
        </div>
        <div class="overflow-hidden border border-gray-200 shadow md:rounded-b-lg">
          <GlobalTransactionGrid
              :data1="gridData"
              :columns="gridColumns"
              :columns-displayed="gridColumnsDisplayed"
              :filter-key="searchQuery"
              :page="1"
              :per-page="25"
              :pages="[]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {
  ChevronDownIcon,
  CreditCardIcon,
  DownloadIcon,
  DuplicateIcon,
  OfficeBuildingIcon,
  SearchIcon,
  UserIcon,
  UsersIcon
} from '@heroicons/vue/solid'
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {ref} from 'vue'

const people = [
  {id: 1, name: 'Wade Cooper'},
  {id: 2, name: 'Arlene Mccoy'},
  {id: 3, name: 'Devon Webb'},
  {id: 4, name: 'Tom Cook'},
  {id: 5, name: 'Tanya Fox'},
  {id: 6, name: 'Hellen Schmidt'},
  {id: 7, name: 'Caroline Schultz'},
  {id: 8, name: 'Mason Heaney'},
  {id: 9, name: 'Claudie Smitham'},
  {id: 10, name: 'Emil Schaefer'},
]

const selected = ref(people[3])
const tabs = [
  {name: 'Rapports', href: '/global_transaction', icon: DownloadIcon, current: false},
  {name: 'Toutes', href: '/global_transaction/all', icon: UserIcon, current: false},
  {name: 'Paypal', href: '/global_transaction/paypal', icon: UsersIcon, current: true},
  {name: 'Stripe', href: '/global_transaction/stripe', icon: OfficeBuildingIcon, current: false},
  {name: 'Dedipass', href: '/global_transaction/dedipass', icon: CreditCardIcon, current: false},
  {name: 'xMoney', href: '/global_transaction/xmoney', icon: CreditCardIcon, current: false},
  {name: 'Nowpayments', href: '/global_transaction/nowpayments', icon: CreditCardIcon, current: false},
  {name: 'Entreprise - Europe', href: '/global_transaction/enterprise_europe', icon: CreditCardIcon, current: false},
  {name: 'Hors Europe', href: '/global_transaction/except_europe', icon: CreditCardIcon, current: false},
]

</script>


<script>
import GlobalTransactionGrid from './GlobalTransactionGrid.vue'
import axios from "axios";
import moment from 'moment'
import {openReportPdf} from '@/composables/reportService'


export default {
  components: {
    GlobalTransactionGrid
  },
  props: {
    endpoint: String,
    date: String,
    gateway: String
  },
  data: () => ({
    showAdd: false,
    dateChoose: null,
    gridColumnsDisplayed: {
      date: "Date",
      gateway: "Banque",
      type: "Type",
      description: "Description",
      amount: "Montant",
      fee: "Frais",
      whmcs_country: "Pays (WH)",
      whmcs_amount: "Montant (WH)",
      whmcs_tax_id: "TVA (WH)",
    },
    gridColumns: ['date', 'gateway', 'type'],
    gridData: [],
    searchQuery: '',
    polling: null,
    startDate: new Date('2025-09-01'),
    endDate: new Date('2026-09-31'),
    monthYearList: [],
  }),
  created() {
    this.dateChoose = localStorage.getItem('dateChoose') || new Date().toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit'
    });
  },
  computed: {
    statisticsTitle() {
      return {
        'global_transaction/all': 'Transactions clients',
        'global_transaction/paypal': 'Transactions Paypal',
        'global_transaction/stripe': 'Transactions Stripe',
        'global_transaction/dedipass': 'Transactions Dedipass',
        'global_transaction/xmoney': 'Transactions xMoney',
        'global_transaction/nowpayments': 'Transactions Nowpayments',
        'global_transaction/enterprise_europe': 'Entreprise - Europe',
        'global_transaction/except_europe': 'Hors Europe',
      }[this.endpoint] || 'Transactions clients';
    },
    statistics() {
      let total = 0;
      let fees = 0;
      this.gridData.forEach((t) => {
        total += parseFloat(t.amount) || 0;
        fees += Math.abs(parseFloat(t.fee) || 0);
      });
      return {
        count: this.gridData.length,
        total: total.toFixed(2),
        fees: fees.toFixed(2),
        net: (total - fees).toFixed(2),
      };
    },
    // Utilisez une propriété calculée pour générer la liste des mois et années
    // entre les deux dates.
    generateMonthYearList() {
      const currentDate = new Date();
      const endDate = new Date(this.endDate);
      const monthYearList = [];
      const fiscalYearsAdded = new Set();

      // Utilisez un clone de startDate pour éviter de modifier la valeur initiale
      let currentMonth = new Date(this.startDate);

      let currentYear = currentMonth.getFullYear(); // Initialisez la variable de l'année en cours

      while (currentMonth <= endDate) {
        const year = currentMonth.getFullYear();
        const month = currentMonth.toLocaleString('default', {month: '2-digit'});

        // Ajoutez l'année au début de la liste si c'est le début d'une nouvelle année
        if (!monthYearList.includes(year.toString()) && year.toString() <= new Date().getFullYear().toString()) {
          monthYearList.push(year.toString());
        }

        // Ajoutez l'exercice fiscal (sept N -> août N+1) qui contient ce mois
        const fyStart = currentMonth.getMonth() >= 8 ? year : year - 1;
        const fyKey = `Exercice ${fyStart}-${fyStart + 1}`;
        if (!fiscalYearsAdded.has(fyKey)) {
          fiscalYearsAdded.add(fyKey);
          monthYearList.push(fyKey);
        }

        // Ajoutez le mois à la liste uniquement si la date actuelle n'est pas dans le futur
        if (currentMonth <= currentDate) {
          monthYearList.push(`${year}-${month}`);
        }

        // Incrémente la date d'un mois
        currentMonth.setMonth(currentMonth.getMonth() + 1);
      }

      return monthYearList;
    },
  },
  watch: {
    // Mettez à jour la liste lorsque les dates changent
    startDate: 'updateMonthYearList',
    endDate: 'updateMonthYearList',
  },
  mounted() {
    this.searchQuery = this.getFromLocalStorage('filterKey')
    this.fetchTransactionData()
    this.intervalFetchData()
    this.monthYearList = this.generateMonthYearList;
  },
  beforeUnmount() {
    clearInterval(this.polling)
  },
  methods: {
    // Rapport PDF servi par billing.clafoutis.eu (authentifié), sur la période affichée
    openReport(reportKey, variant) {
      const range = this.getMonthStartEndDates(this.dateChoose);
      openReportPdf(reportKey, variant, range.start, range.end);
    },
    getMonthStartEndDates(input) {
      // Cas spécial: exercice fiscal "Exercice YYYY-YYYY" (1er sept -> 31 août)
      if (typeof input === 'string' && input.startsWith('Exercice ')) {
        const startYear = parseInt(input.replace('Exercice ', '').split('-')[0], 10);
        const startDate = new Date(startYear, 8, 2); // 1er sept (mois 0-indexé)
        const endDate = new Date(startYear + 1, 7, 32); // 31 août
        return {
          start: startDate.toISOString().slice(0, 10),
          end: endDate.toISOString().slice(0, 10),
        };
      }

      const [year, month] = input.split('-').map(Number);

      if (isNaN(month)) {
        // Si l'entrée ne contient pas de mois, cela signifie que c'est une année seule
        const startDate = new Date(year, 0, 2); // Le mois est 0-indexé, 0 représente janvier.
        const endDate = new Date(year, 11, 32); // 11 représente décembre.

        // Formatez les dates au format "YYYY-MM-DD"
        const formattedStartDate = startDate.toISOString().slice(0, 10);
        const formattedEndDate = endDate.toISOString().slice(0, 10);

        return {
          start: formattedStartDate,
          end: formattedEndDate,
        };
      }

      const startDate = new Date(year, month - 1, 2); // Le mois est 0-indexé, donc soustrayez 1.
      const endDate = new Date(year, month, 1); // La date 0 du mois suivant est la dernière du mois actuel.

      // Formatez les dates au format "YYYY-MM-DD"
      const formattedStartDate = startDate.toISOString().slice(0, 10);
      const formattedEndDate = endDate.toISOString().slice(0, 10);

      return {
        start: formattedStartDate,
        end: formattedEndDate,
      };
    },
    formatDateComplet(value) {
      if (value) {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return '';
    },
    updateDateChoose(date) {
      this.fetchTransactionData();
      this.dateChoose = date;
      localStorage.setItem('dateChoose', date);
    },
    updateMonthYearList() {
      this.monthYearList = this.generateMonthYearList;
    },
    intervalFetchData: function () {
      this.polling = setInterval(() => {
        this.fetchTransactionData();
      }, 10000);
    },
    saveToLocalStorage(item, value) {
      localStorage.setItem(item, value);
    },
    getFromLocalStorage(item) {
      return localStorage.getItem(item);
    },
    async fetchTransactionData() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      const hasDate = this.dateChoose && this.dateChoose !== "null"
      let request
      if (this.endpoint.endsWith('/day')) {
        // Vue journalière : résumé d'un jour, on garde la date positionnelle
        request = HTTP.get(hasDate ? `${this.endpoint}/${this.dateChoose}` : this.endpoint)
      } else {
        // Le front convertit mois / année / exercice en plage concrète ; l'API ne fait qu'un whereBetween
        const range = hasDate ? this.getMonthStartEndDates(this.dateChoose) : null
        request = HTTP.get(this.endpoint, { params: range ? { start: range.start, end: range.end } : {} })
      }

      request
          .then(response => {
            const {transactions} = response.data
            const gridData = []
            transactions.forEach((value) => {
              gridData.push({
                id: value['id'],
                gateway: value['gateway'],
                type: value['type'],
                amount: value['amount'] + " €",
                fee: value['fee'] ? value['fee'] + " €" : null,
                description: value['description'],
                whmcs_country: value['whmcs_country'],
                whmcs_amount: value['whmcs_amount'] ? value['whmcs_amount'] + " €" : null,
                whmcs_tax_id: value['whmcs_tax_id'],
                date: value['date'] ? moment(value['date']).format('YYYY-MM-DD') : null,
                button: value['id'],
              })
            });
            if (gridData !== this.gridData) {
              this.gridData = gridData
            }
          }).catch(e => {
        console.log(e)
      })
    },
    truncate(v) {
      const newline = v.indexOf('\n')
      return newline > 0 ? v.slice(0, newline) : v
    },
    formatDate(v) {
      return v.replace(/T|Z/g, ' ')
    }
  }
}
</script>
